interface MensajeEstamosEnElloProps {
  servicio?: string;
  className?: string;
}

const MensajeEstamosEnEllo: React.FC<MensajeEstamosEnElloProps> = ({
  servicio,

}) => {


  return (
    <div
        className="w-full max-w-xl h-40 flex items-center justify-center mx-auto mt-10 border border-zinc-300 rounded-xl shadow-lg  bg-white text-center px-6 text-zinc-700 text-lg font-semibold relative opacity-0 animate-fadeIn "
        style={{ animationFillMode: 'forwards', animationDuration: '1s' }}
      >
        <p>
          ¡Estamos trabajando en ello!<br />
          Muy pronto tendrás <strong className="text-indigo-600">{servicio}</strong> disponibles por aquí.
        </p>
      </div>
  );
};

export default MensajeEstamosEnEllo;
